import axios from 'axios/index'

const namespaced = true

const state = {
  loading: true,
  token: '',
  user: {}
}
const actions = {
  getToken ({ commit, state }, data) {
    return axios.post('/api/private/v3.0/companies/' + data.company_id + '/users/' + data.user_id + '/activate/', { token: data.token })
      .then(response => {
        localStorage.setItem('token_castle_authorization', 'Token ' + response.data.token)
        commit('setActivateData', response.data)
        commit('setLoading', false)
        axios.defaults.headers.common.Authorization = 'Token ' + response.data.token
      })
      .catch(error => {
        console.log(error)
      })
  }
}
const mutations = {
  setActivateData (state, data) {
    console.log(data)
    state.token = data.token
    state.user = data.user
  },
  setLoading (state) {
    state.loading = false
  }
}
const getters = {}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
